import { PasseriniAPI } from '@/services/apiService';
import type { DestinoPago, DestinoPagoFormData, DestinoPagoOpcion } from '../types';

const BASE = '/presupuesto-destinos-pago';

export const destinoPagoService = {
  /** Listado completo, con los datos de cada cuenta (Configuración del Sistema). */
  listar: async (): Promise<DestinoPago[]> => {
    const response = await PasseriniAPI.get(BASE);
    return response.data.destinos;
  },

  /** Opciones para los formularios de ítems: sin los datos de las cuentas. */
  opciones: async (): Promise<DestinoPagoOpcion[]> => {
    const response = await PasseriniAPI.get(`${BASE}/opciones`);
    return response.data.destinos;
  },

  crear: async (data: DestinoPagoFormData): Promise<DestinoPago> => {
    const response = await PasseriniAPI.post(BASE, data);
    return response.data;
  },

  actualizar: async (id: string, data: Partial<DestinoPagoFormData>): Promise<DestinoPago> => {
    const response = await PasseriniAPI.put(`${BASE}/${id}`, data);
    return response.data;
  },

  eliminar: async (id: string): Promise<void> => {
    await PasseriniAPI.delete(`${BASE}/${id}`);
  },

  marcarDefault: async (id: string): Promise<DestinoPago[]> => {
    const response = await PasseriniAPI.post(`${BASE}/${id}/default`);
    return response.data.destinos;
  },

  reordenar: async (ids: string[]): Promise<DestinoPago[]> => {
    const response = await PasseriniAPI.post(`${BASE}/reordenar`, { ids });
    return response.data.destinos;
  },
};
